import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DialogService } from '../../services';

@Component({
  selector: 'prism-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss']
})
export class ConfirmModalComponent implements OnInit {

  confirmMessage: string;

  constructor(private dialogService: DialogService, public dialogRef: MatDialogRef<ConfirmModalComponent>) {
  }

  ngOnInit() {
    this.confirmMessage = this.dialogService.inputData.confirmMessage;
  }

}
